const SubscribeDetailsCardStyle = () => `
<style>
    .card-details-container {
        display: flex;
        flex-direction: column;
        padding: 20px;
        border-radius: 11px;
        background: #FFF;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
        max-width: 320px;
        margin: 10px 0 25px;
    }

    .canceled {
        color: #717575;
        font-size: 14px;
    }

    .date {
        font-family: 'Spectral-ExtraLight';
        font-size: 28px;
        font-weight: 275;
    }

    .date-information {
        display: flex;
        align-items: center;
        gap: 20px;
        margin: -30px 0 -25px;
    }

    .frequency-badge {
        display: flex;
        padding: 4px 12px;
        border-radius: 6px;
        background: #D2EAE5;
        font-size: 10px;
    }

    .button-resubscribe {
        border-radius: 11px;
        color: white;
        background: #000;
        height: 40px;
        width: 100%;
        cursor: pointer;
    }

    .resubscribe-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .edit-link-container {
        line-height: 26px;
    }

    .edit-link {
        color: #000;
    }

    .modal {
        z-index: 3;
        display: none;
        padding-top: 100px;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .modal-content {
        margin: auto;
        background-color: #fff;
        position: relative;
        padding: 0;
        outline: 0;
        width: 600px;
        display: flex;
        flex-direction: column;
        border-radius: 10px
    }

    .modal-container {
        padding: 0.01em 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;
    }

    @media (max-width: 768px) {
        .modal-content {
            width: 90%;
        }
    }

    .close-button {
        align-self: flex-end;
        cursor: pointer;
        font-size: 24px;
        margin: 10px;
    }

    .modal-title {
        font-family: 'Spectral-ExtraLight';
    }

    .cta-button {
        margin-bottom: 20px;
        border-radius: 11px;
        color: black;
        background: white;
        height: 40px;
        width: 50%;
        cursor: pointer;
    }
</style>`;

export default SubscribeDetailsCardStyle;
